<template>
  <v-navigation-drawer
    :mini-variant-width="70"
    :permanent="!isMobile"
    :expand-on-hover="!isMobile"
    v-model="isMenuOpen"
    :style="{ height: '100%', zIndex: 15 }"
  >
    <div
      class="sidebar"
      @mouseenter="isShowingFullLogo = true"
      @mouseleave="isShowingFullLogo = false"
    >
      <img
        v-if="!isShowingFullLogo"
        :src="require('@assets/images/logo-simbolo.png')"
        alt="Avalia logo"
        class="mt-4 mx-auto d-block"
        width="44"
      />
      <img
        v-else
        :src="require('@assets/images/logo-avalia.png')"
        alt="Avalia logo"
        class="mt-4 mx-auto d-block"
        width="114"
      />

      <div class="mt-8 d-flex ml-3" :class="{ 'profile': !isShowingFullLogo }">
        <v-avatar class="cursor-pointer" @click="$router.push('/aluno/perfil')">
          <v-img
            :src="usuario.foto"
          />
        </v-avatar>
        <div v-if="isShowingFullLogo" class="ml-3">
          <p class="mb-0">{{ usuario.nome }}</p>
          <router-link to="/aluno/perfil">Ver Perfil</router-link>
        </div>
      </div>
      <hr class="mx-4 gray-300 mt-4 mb-1">
      <v-list class="px-2">
        <v-list-item
          v-for="(menu, i) in menus"
          :key="'menu-aluno-' + i"
          @click="onClickFunction(menu)"
          class="d-flex align-center grey--text"
          :class="{
            'lista--ativa': rotaAtiva(menu.rota),
            'mb-5': menu.titulo === 'Seus Arquivos',
          }"
        >
          <v-list-item-icon
            class="d-flex align-center justify-center mx-0 my-auto"
          >
            <!-- <component :is="menu.icon" color="#fff" /> -->
            <v-img
              contain
              max-width="30"
              max-height="30"
              :src="menu.icon"
            />
            <component :is="menu.icon" />

            <div
              v-if="menu.titulo === 'Livros'"
              class="divisor mb-2"
            />
          </v-list-item-icon>

          <v-list-item-title
            class="ms-5"
            :style="{ whiteSpace: 'normal' }"
          >
            {{ menu.titulo }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>

    <!--      <v-list class="px-2" v-show="privilegio == 5">-->
    <!--        <v-list-item-->
    <!--            v-for="(menu, i) in menusConteudo"-->
    <!--            :key="'menu-conteudo-' + i"-->
    <!--            @click="clickAcaoMenu(menu)"-->
    <!--            class="white&#45;&#45;text"-->
    <!--            :class="{'lista&#45;&#45;ativa': rotaAtiva(menu.rota), 'mb-3': menu.titulo === 'Relatório das Questões'}"-->
    <!--        >-->
    <!--          <v-list-item-icon class="my-auto">-->
    <!--            &lt;!&ndash; <component :is="menu.icon" color="#fff" /> &ndash;&gt;-->
    <!--            <v-img max-width="30" max-height="30" :src="menu.icon"/>-->
    <!--            <div v-if="menu.titulo === 'Relatório das Questões'" class="divisor"></div>-->
    <!--          </v-list-item-icon>-->

    <!--          <v-list-item-title class="my-2" :style="{ whiteSpace: 'normal' }">-->
    <!--            {{ menu.titulo}}-->
    <!--          </v-list-item-title>-->
    <!--        </v-list-item>-->
    <!--      </v-list>-->

    <ModalSair
      v-if="modalSairPlataformaAberto"
      descricao="Você realmente deseja sair da plataforma?"
      :modal-aberto="modalSairPlataformaAberto"
      @close-modal="modalSairPlataformaAberto = false"
      @continuar="modalSairPlataformaAberto = false"
      @sair="
        modalSairPlataformaAberto = false;
        $router.replace('/login');
      "
    />
    <ModalPaginaConstrucao
      @close-modal="modalPaginaConstrucaoAberto = false"
      :modal-aberto="modalPaginaConstrucaoAberto"
    />
  </v-navigation-drawer>
</template>

<script>
import ModalSair from "@/pages/aluno/ModalSair.vue";
import ModalPaginaConstrucao from "../ModalPaginaConstrucao.vue";
import alerts from "@/alerts";
import SignOut from "@/components/icons/SignOut.vue";
import House from "@/components/icons/House.vue";
import Desktop from "@/components/icons/Desktop.vue";
import QuestionMark from "@/components/icons/QuestionMark.vue";

export default {
  name: "NavbarAluno",
  props: ["toggleMenu", "user"],
  mixins: [alerts],
  components: { ModalSair, ModalPaginaConstrucao },
  data() {
    return {
      isMenuOpen: false,
      isShowingFullLogo: false,
      modalSairPlataformaAberto: false,
      modalPaginaConstrucaoAberto: false,
      menus: [
        {
          titulo: "Início",
          // icon: House,
          icon: House,
          rota: "/aluno/home",
        },
        // {
        //   titulo: "Componentes Curriculares",
        //   // icon: House,
        //   icon: "/assets/icones/aluno/menu-unidade.svg",
        //   rota: "/aluno/disciplinas",
        //   value: "disciplinas",
        // },
        {
          icon: Desktop,
          id: 12,
          ordem: 12,
          rota: "/aluno/disciplinas",
          status: "Ativo",
          titulo: "Recursos Educacionais",
        },
        // {
        //   icon: "/assets/icones/aluno/menu-acompanhamento.svg",
        //   id: 17,
        //   ordem: 17,
        //   rota: "/aluno/acompanhamento",
        //   status: "Ativo",
        //   titulo: "Acompanhamento",
        // },
        // {
        //   titulo: "Mural",
        //   // icon: House,
        //   icon: "/assets/icones/aluno/menu-mural.svg",
        //   rota: "/aluno/mural",
        // },
        // {
        //   titulo: "Agenda",
        //   // icon: House,
        //   icon: "/assets/icones/aluno/menu-agenda.svg",
        //   rota: "/aluno/agenda",
        // },
        // {
        //   titulo: "Mensagens",
        //   // icon: House,
        //   icon: "/assets/icones/aluno/menu-mensagens.svg",
        //   rota: "/aluno/mensagens",
        // },
        // {
        //   titulo: "Acompanhamento",
        //   // icon: House,
        //   icon: "/assets/icones/aluno/menu-acompanhamento.svg",
        //   rota: "/aluno/acompanhamento",
        // },
        //
        // {
        //   titulo: "Games",
        //   // icon: House,
        //   icon: "/assets/icones/aluno/menu-games.svg",
        //   rota: "#",
        // },
        {
          titulo: "Ajuda",
          icon: QuestionMark,
          rota: "/aluno/faq",
        },
        {
          titulo: "Sair",
          icon: SignOut,
          // icon: Logout,
          rota: "sair",
          onClickFunction: () => {
            this.sair();
          },
        },
      ],
    };
  },
  methods: {
    rotaAtiva(rota) {
      return this.$route.fullPath.indexOf(rota) !== -1;
    },
    clickAcaoMenu(menu) {
      if (menu.rota == this.$router.currentRoute.path) {
        return;
      }
      if (menu.rota == "#") {
        this.modalPaginaConstrucaoAberto = true;
      } else if (menu.rota != this.$router.fullPath) {
        this.$router.push(menu.rota);
      }
    },
    onClickFunction(menu) {
      if (menu.onClickFunction) {
        menu.onClickFunction();
      } else {
        this.clickAcaoMenu(menu);
      }
    },
    sair() {
      this.modalSairPlataformaAberto = true;
    },
  },
  watch: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600;
    },
    usuario() {
      return this.$store.getters["usuarioStore/user"];
    },
  },
};
</script>

<style scoped lang="scss">
.v-responsive__content {
  width: unset !important;
}
.lista--ativa {
  background: #e4f1fa;
  color: #122859 !important;
  border-radius: 30px;
}
.sidebar {
  height: 90%;
}
.cursor-pointer {
  cursor: pointer;
}
.profile {
  width: 48px;
}
</style>
